import React from 'react';
import { useTranslation } from 'react-i18next';
import './LanguageSelector.css';

/**
 * 언어 선택 컴포넌트
 * 한국어, 영어, 프랑스어 중에서 선택할 수 있는 셀렉트 박스
 */
const LanguageSelector: React.FC = () => {
  const { i18n, t } = useTranslation();

  // 지원되는 언어 목록
  const supportedLanguages = ['ko', 'en', 'fr'];

  // 언어 변경 핸들러
  const handleLanguageChange = (event: React.ChangeEvent<HTMLSelectElement>) => {
    const newLanguage = event.target.value;
    
    // 지원되는 언어인지 확인
    if (supportedLanguages.includes(newLanguage)) {
      i18n.changeLanguage(newLanguage);
      
      // localStorage에 언어 설정 저장
      localStorage.setItem('i18nextLng', newLanguage);
    } else {
      // 지원되지 않는 언어인 경우 영어로 설정
      i18n.changeLanguage('en');
      localStorage.setItem('i18nextLng', 'en');
    }
  };

  return (
    <div className="language-selector">
      <select
        value={i18n.language}
        onChange={handleLanguageChange}
        className="language-select"
        aria-label={t('language.selectLanguage') as string}
      >
        <option value="ko">{t('language.ko')}</option>
        <option value="en">{t('language.en')}</option>
        <option value="fr">{t('language.fr')}</option>
      </select>
    </div>
  );
};

export default LanguageSelector; 